import { useRef, useState } from 'react';
import uuid from 'react-uuid';

import * as S from '@/components/common/Tab/TabList/style';
import useClickOutside from '@/hooks/useClickOutSide';
import useIsMobile from '@/hooks/useIsMobile';
import { breakpoints } from '@/styles/breakpoints';

import ArrowDownIcon from '../../../Icon/ArrowDownIcon';

interface TabListProps {
	menuList: string[];
	menuKey: string;
	isNotSticky?: boolean;
	onListClick: (menu: string) => void;
}

const TabList = ({ menuList, menuKey, onListClick, isNotSticky = false }: TabListProps) => {
	const isMobile = useIsMobile(breakpoints.layout);
	const [open, setOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleSelect = (option: string) => {
		setOpen(false);
		onListClick(option);
	};

	useClickOutside(dropdownRef, () => setOpen(false));

	return (
		<>
			{!isMobile && (
				<S.TabListContainer isNotSticky={isNotSticky}>
					{menuList.map((menu, index) => (
						<S.TabListItem key={index} className={menuKey === menu ? 'active' : ''} onClick={() => onListClick(menu)}>
							{menu}
						</S.TabListItem>
					))}
				</S.TabListContainer>
			)}
			{isMobile && (
				<S.DropdownContainer isNotSticky={isNotSticky}>
					<S.DropdownWrapper isNotSticky={isNotSticky} ref={dropdownRef}>
						<S.DropdownButton onClick={() => setOpen(!open)}>
							{menuKey}

							<S.ArrowDown open={open}>
								<ArrowDownIcon />
							</S.ArrowDown>
						</S.DropdownButton>
						<S.DropdownList open={open}>
							{menuList.map((option) => (
								<S.DropdownItem key={uuid()} onClick={() => handleSelect(option)}>
									{option}
								</S.DropdownItem>
							))}
						</S.DropdownList>
					</S.DropdownWrapper>
				</S.DropdownContainer>
			)}
		</>
	);
};

export default TabList;
